import React, { useState } from 'react'
import {
  CBadge,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CSmartTable,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilOptions, cilPencil, cilTrash, cilInputPower } from '@coreui/icons'
import moment from 'moment'
import ToastComponent from 'src/components/common/TaostComponent.js'
import PlayerService from 'src/service/PlayerService'
import Notify from '../Notify'
import CommonService from 'src/service/CommonService'

const columns = [
  { label: 'Player', key: 'full_name', filter: false },
  { label: 'Team', key: 'team_name', filter: false },
  { label: 'Position', key: 'position_name', filter: false },
  { label: 'Value', key: 'svalue', filter: false },
  { label: 'Availability', key: 'availability', filter: false, sorter: false },
  { label: 'Category', key: 'category_name', filter: false, sorter: false },
  { label: 'Sponsor', key: 'sponsor_name', filter: false, sorter: false },
  { label: 'Status', key: 'is_active', filter: false },
  { key: 'actions', label: 'Actions', filter: false, sorter: false },
]

const MISSING_LABEL = {
  team: 'Missing team',
  position: 'Missing position',
  value: 'Missing value',
  image: 'Missing image',
}

const Table = ({
  users,
  fetchUsers,
  setActivePage,
  setItemsPerPage,
  setColumnSorter,
  itemsPerPage,
  activePage,
  columnSorter,
  loading,
  visibleColumns,
  selectedItems,
  onSelectedItemsChange,
  onOpenPlayer,
}) => {
  const visibleColumnDefs = columns.filter((col) => {
    if (['full_name', 'actions'].includes(col.key)) return true
    return visibleColumns?.[col.key] !== false
  })

  const deletePlayer = (id) => {
    const data = {}
    data.id = id
    PlayerService.deletePlayer(data).then((res) => {
      if (res.status === 200) {
        fetchUsers()
        ToastComponent(res.message, 'success')
      }
    })
  }

  // Are you sure want modal
  const [handleYes, setHandleYes] = useState(false)
  const [statusHandleYes, setStatusHandleYes] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [statusShowConfirm, setStatusShowConfirm] = useState(false)
  const [handleNo, setHandleNo] = useState(false)
  const [statusHandleNo, setStatusHandleNo] = useState(false)
  const [tableId, setTableId] = useState(false)
  const [playerStatus, setPlayerStatus] = useState(false)

  const handleCancel = () => setShowConfirm(false)
  const handleStatusCancel = () => setStatusShowConfirm(false)

  const handleConfirm = () => {
    deletePlayer(tableId)
    return setShowConfirm(false)
  }
  const handleStatusConfirm = () => {
    handleStatus(tableId, playerStatus)
    return setStatusShowConfirm(false)
  }
  const areYouSureModal = (id) => {
    const data = {}
    data.id = id
    data.type = 'player'
    CommonService.checkItemExists(data).then((res) => {
      if (res.status === 200) {
        if (res.data) {
          ToastComponent(res.message, 'error')
        } else {
          setShowConfirm(true)
          setTableId(id)
        }
      }
    })
  }
  const handleAreYouSureStatus = (id, status) => {
    const data = {}
    data.id = id
    data.type = 'player_status'
    CommonService.checkItemExists(data).then((res) => {
      if (res.status === 200) {
        if (res.data) {
          ToastComponent(res.message, 'error')
        } else {
          setStatusShowConfirm(true)
          setTableId(id)
          setPlayerStatus(status)
        }
      }
    })
  }

  const handleStatus = (id, status) => {
    PlayerService.updateStatus(id, status)
      .then((res) => {
        if (res.status === 200) {
          fetchUsers()
          ToastComponent(res.message, 'success')
        }
      })
      .catch((e) => {
        console.log('Catch Block', e)
      })
  }

  return (
    <div className="ge-datatable ge-datatable--static">
      <CSmartTable
        columns={visibleColumnDefs}
        selectable
        selected={selectedItems}
        onSelectedItemsChange={onSelectedItemsChange}
        columnSorter={{
          external: true,
        }}
        sorterValue={columnSorter}
        scopedColumns={{
          full_name: (item) => {
            const imgSrc =
              item?.is_avatar === 1
                ? `${process.env.REACT_APP_PLAYER_AVATAR_URL}${item.image}`
                : `${process.env.REACT_APP_API_URL}uploads/player/${item.image}`
            return (
              <td>
                <div
                  className="d-flex align-items-center"
                  role="button"
                  onClick={() => onOpenPlayer(item.id)}
                >
                  <img
                    src={imgSrc}
                    alt="img"
                    width="40"
                    height="40"
                    className="rounded-circle me-2"
                  />
                  <div>
                    <div className="fw-semibold text-primary">{item.full_name}</div>
                    <div className="text-medium-emphasis small">{item.id}</div>
                    {item.missing_reasons?.length > 0 && (
                      <div className="text-danger small">
                        {item.missing_reasons.map((r) => MISSING_LABEL[r] || r).join(', ')}
                      </div>
                    )}
                  </div>
                </div>
              </td>
            )
          },
          svalue: (item) => <td>${item.svalue}m</td>,
          availability: (item) => {
            if (item.availability_status !== 'unavailable') {
              return (
                <td>
                  <CBadge color="success">Available</CBadge>
                </td>
              )
            }
            const isUpcoming = moment(item.availability_from).isAfter(moment(), 'day')
            return (
              <td>
                <CBadge color="warning">
                  {isUpcoming
                    ? `From ${moment(item.availability_from).format('D MMM')}`
                    : `Until ${moment(item.availability_until).format('D MMM')}`}
                </CBadge>
              </td>
            )
          },
          category_name: (item) => <td>{item.category_name || '—'}</td>,
          sponsor_name: (item) => <td>{item.sponsor_name || '—'}</td>,
          is_active: (item) => (
            <td>
              {item.in_use === 1 ? (
                <CBadge color="success">In-Use</CBadge>
              ) : (
                <CBadge color="secondary">Not In Use</CBadge>
              )}
            </td>
          ),
          actions: (item) => (
            <td className="py-2">
              <CDropdown alignment="end" placement="bottom-end" portal>
                <CDropdownToggle color="transparent" caret={false} className="p-0">
                  <CIcon icon={cilOptions} role="button" />
                </CDropdownToggle>
                <CDropdownMenu className="ge-row-actions-menu">
                  <CDropdownItem role="button" onClick={() => onOpenPlayer(item.id)}>
                    <CIcon icon={cilPencil} className="me-2" />
                    Edit
                  </CDropdownItem>
                  {item.is_active === 1 ? (
                    <CDropdownItem role="button" onClick={() => handleAreYouSureStatus(item.id, 0)}>
                      <CIcon icon={cilInputPower} className="me-2" />
                      Deactivate
                    </CDropdownItem>
                  ) : (
                    <CDropdownItem role="button" onClick={() => handleAreYouSureStatus(item.id, 1)}>
                      <CIcon icon={cilInputPower} className="me-2" />
                      Activate
                    </CDropdownItem>
                  )}
                  <CDropdownItem
                    role="button"
                    className="text-danger"
                    onClick={() => areYouSureModal(item.id)}
                  >
                    <CIcon icon={cilTrash} className="me-2" />
                    Delete
                  </CDropdownItem>
                </CDropdownMenu>
              </CDropdown>
            </td>
          ),
        }}
        items={users?.data}
        itemsPerPage={itemsPerPage}
        itemsPerPageSelect
        loading={loading}
        pagination={{
          external: true,
        }}
        paginationProps={{
          activePage: activePage,
          pages: Math.ceil(users?.total / itemsPerPage) || 1,
        }}
        tableProps={{ hover: true, responsive: true, className: 'align-middle mb-0' }}
        onActivePageChange={(activePage) => setActivePage(activePage)}
        onItemsPerPageChange={(itemsPerPage) => {
          setActivePage(1)
          setItemsPerPage(itemsPerPage)
        }}
        onSorterChange={(sorter) => setColumnSorter(sorter)}
      />
      <Notify
        setShowConfirm={setShowConfirm}
        showConfirm={showConfirm}
        setHandleNo={setHandleNo}
        handleNo={handleNo}
        handleYes={handleYes}
        setHandleYes={setHandleYes}
        handleConfirm={handleConfirm}
        handleCancel={handleCancel}
        text="Are you sure you want to delete this?"
      />
      <Notify
        setShowConfirm={setStatusShowConfirm}
        showConfirm={statusShowConfirm}
        setHandleNo={setStatusHandleNo}
        handleNo={statusHandleNo}
        handleYes={statusHandleYes}
        setHandleYes={setStatusHandleYes}
        handleConfirm={handleStatusConfirm}
        handleCancel={handleStatusCancel}
        text="Are you sure you want to change player status?"
      />
    </div>
  )
}

export default Table
